export enum EBuidlingHouseLine {
  First = 1,
  Second = 2,
}
